<script setup>
import { onMounted } from 'vue';
import { VueFinalModal } from 'vue-final-modal';
import { useForm, Link } from '@inertiajs/vue3';
import InputError from '@/Components/InputError.vue';

const emit = defineEmits(['confirm']);

const getCookie = (name) => {
    const value = `; ${document.cookie}`;
    const parts = value.split(`; ${name}=`);
    if (parts.length === 2) return parts.pop().split(';').shift();
    return null;
};

const form = useForm({
    email: '',
    password: '',
    remember: true,
    _ym_uid: null,
    redirect: window.location.href,
});

onMounted(() => {
    form._ym_uid = getCookie('_ym_uid');
});

const submit = () => {
    form.post(route('login'), {
        onFinish: () => form.reset('password'),
        onSuccess: () => emit('confirm'),
    });
};
</script>

<template>
    <VueFinalModal
        class="flex items-center justify-center"
        content-class="bg-white rounded-xl shadow-xl w-full max-w-sm mx-4"
        overlay-transition="vfm-fade"
        content-transition="vfm-fade"
    >
        <div class="px-6 py-6">
            <h2 class="text-lg font-semibold text-gray-900 mb-4">Вход</h2>

            <a
                href="/auth/yandex"
                class="flex items-center justify-center gap-2 w-full px-3 py-2.5 rounded-lg bg-[#FC3F1D] hover:bg-[#e63615] text-white text-sm font-medium transition-colors mb-4"
            >
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" class="w-5 h-5 shrink-0">
                    <path fill="white" d="M2.04 12c0-5.523 4.476-10 9.998-10C17.522 2 22 6.477 22 12s-4.478 10-10.002 10C6.516 22 2.04 17.523 2.04 12Z"/>
                    <path fill="#FC3F1D" d="M13.32 7.666h-.924c-1.694 0-2.585.858-2.585 2.123 0 1.43.616 2.1 1.881 2.959l1.045.704-3.003 4.548H7.919l2.771-4.133c-1.573-1.12-2.464-2.21-2.464-4.02 0-2.288 1.573-3.838 4.576-3.838h2.464v11.99H13.32V7.666Z"/>
                </svg>
                Войти через Яндекс ID
            </a>

            <div class="flex items-center gap-2 text-xs text-gray-500 mb-4">
                <div class="flex-1 h-px bg-gray-200"></div>
                или по email
                <div class="flex-1 h-px bg-gray-200"></div>
            </div>

            <form @submit.prevent="submit" class="space-y-4">
                <div>
                    <label for="lm-email" class="block text-sm font-medium text-gray-700 mb-1">Email</label>
                    <input
                        id="lm-email"
                        type="email"
                        v-model="form.email"
                        required
                        autofocus
                        autocomplete="username"
                        class="w-full rounded-lg border-gray-300 shadow-sm focus:border-indigo-500 focus:ring-indigo-500 text-sm"
                    />
                    <InputError :message="form.errors.email" class="mt-1" />
                </div>

                <div>
                    <label for="lm-password" class="block text-sm font-medium text-gray-700 mb-1">Пароль</label>
                    <input
                        id="lm-password"
                        type="password"
                        v-model="form.password"
                        required
                        autocomplete="current-password"
                        class="w-full rounded-lg border-gray-300 shadow-sm focus:border-indigo-500 focus:ring-indigo-500 text-sm"
                    />
                    <InputError :message="form.errors.password" class="mt-1" />
                </div>

                <div class="flex items-center justify-end">
                    <Link :href="route('password.request')" class="text-sm text-blue-600 hover:underline">
                        Забыли пароль?
                    </Link>
                </div>

                <button
                    type="submit"
                    :disabled="form.processing"
                    class="w-full py-2.5 px-4 bg-indigo-600 hover:bg-indigo-700 disabled:opacity-60 disabled:cursor-not-allowed text-white text-sm font-medium rounded-lg transition-colors flex items-center justify-center gap-2"
                >
                    <svg v-if="form.processing" class="animate-spin h-4 w-4 text-white" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                        <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"/>
                        <path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4z"/>
                    </svg>
                    {{ form.processing ? 'Входим...' : 'Войти' }}
                </button>
            </form>

            <p class="mt-3 text-xs text-gray-500 leading-tight">
                <Link href="/personal" class="underline hover:text-gray-600">Согласие на обработку персональных данных</Link> получено при регистрации.
            </p>

            <div class="mt-3 pt-3 border-t border-gray-100 text-right text-sm">
                <Link :href="route('register')" class="text-gray-500 hover:text-gray-700 hover:underline">
                    Регистрация
                </Link>
            </div>
        </div>
    </VueFinalModal>
</template>
